import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import axios from "axios";

export default function Signup() {
  const validationSchema = yup.object().shape({
    name: yup.string().required("UserName is required"),
    email: yup.string().required("Email is required").email("Email is invalid"),
    companyName: yup.string().required("Company Name is required"),
    phoneNumber: yup.string().min(6).required("Phone Number is required"),
    message: yup.string().min(6).required("Message is required"),
    productType: yup.string().min(6).required("Product Type is required"),
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  async function onSubmit(data) {
    let formData = new FormData();
    formData.append("name", data["name"]);
    formData.append("email", data["email"]);
    formData.append("companyName", data["companyName"]);
    formData.append("phoneNumber", data["phoneNumber"]);
    formData.append("message", data["message"]);
    formData.append("productType", data["productType"]);
    console.log(Object.fromEntries(formData.entries()));
    reset();
    await axios
      .post(
        " http://http://beeboxcloud-lb-443660893.ap-south-1.elb.amazonaws.com/api/enquiry/beebox",
        formData,
      )
      .then((response) => {
        let res = response.data;
        console.log(res);
      });
  }

  return (
    <section
      id="signup"
      className="py-20 px-4 sm:px-6 lg:px-8 bg-[#FFC33A] rounded-t-3xl shadow-2xl"
    >
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
          Ready to Transform Your Enterprise?
        </h2>
        <p className="text-xl text-gray-800 mb-8">
          Start your journey here. Contact us for fully guided onboarding.
        </p>
        <form
          onSubmit={(e) => {
            handleSubmit(onSubmit)(e);

            e.preventDefault();
          }}
          className="max-w-2xl mx-auto"
        >
          <div className="bg-white rounded-2xl p-8 shadow-2xl">
            <div className="grid md:grid-cols-2 gap-4 mb-4">
              <input
                type="text"
                {...register("name")}
                placeholder="Full Name"
                className="px-4 py-3 border-2 border-gray-300 rounded-lg "
              />
              <input
                type="email"
                {...register("email")}
                placeholder="Work Email"
                className="px-4 py-3 border-2 border-gray-300 rounded-lg "
              />
            </div>
            <div className="grid md:grid-cols-2 gap-4 mb-4">
              <input
                type="text"
                {...register("companyName")}
                placeholder="Company Name"
                className="px-4 py-3 border-2 border-gray-300 "
              />
              <input
                type="tel"
                name="phone"
                {...register("phoneNumber")}
                placeholder="Phone Number"
                className="px-4 py-3 border-2 border-gray-300 "
              />
            </div>
            <div className="mb-4">
              <select
                {...register("productType")}
                className="w-full px-4 py-3 border-2 outline-none border-gray-300 rounded-lg "
              >
                <option value="salesbee">SalesBee </option>
                <option value="skillbee">SkillBee </option>
                <option value="check">CheckBee </option>
                <option value="hive">Hive </option>
                <option value="multiple">Multiple Products</option>
              </select>
            </div>
            <div className="mb-4">
              <textarea
                {...register("message")}
                rows="4"
                placeholder="message"
                className="w-full px-4 py-2  rounded-lg border-2 outline-none border-gray-300 "
              ></textarea>
            </div>
            <button
              type="submit"
              onClick={() => console.log("Button clicked")}
              className="w-full py-3 border border-amber-500 text-black text-xs font-medium tracking-[0.35em] uppercase hover:bg-amber-500/10 hover:border-amber-400 active:scale-[0.98] transition-all duration-300"
            >
              Send Message
            </button>

            <p className="text-sm text-gray-500 mt-4">
              No credit card required. Guided onboarding included. Cancel
              anytime.
            </p>
          </div>
        </form>
      </div>
    </section>
  );
}
